import api from "../api/programs";
import {createError, logError, logSuccess} from "./message";
import types from "./types";

  function requestPrograms() {
    return {
      type: types.GET_PROGRAMS_REQUEST,
      isFetchingList: true
    };
  }

  function requestProgramsCompleted(programs) {
    return {
      type: types.GET_PROGRAMS_COMPLETED,
      isFetchingList: false,
      programs
    };
  }

  function requestProgramsError(programsError) {
    return {
      type: types.GET_PROGRAMS_ERROR,
      isFetchingList: false,
      programsError
    };
  }

  function requestProgram() {
    return {
      type: types.GET_PROGRAM_REQUEST,
      isFetchingProgram: true
    };
  }

  function requestProgramCompleted(programCard) {
    return {
      type: types.GET_PROGRAM_COMPLETED,
      isFetchingProgram: false,
      programCard
    };
  }

  function requestProgramError(programCardError) {
    return {
      type: types.GET_PROGRAM_ERROR,
      isFetchingProgram: false,
      programCardError
    };
  }

  function requestFullProgram() {
    return {
      type: types.GET_FULL_PROGRAM_REQUEST,
      isFetchingFullProgram: true
    };
  }

  function requestFullProgramCompleted(programFullInfo) {
    return {
      type: types.GET_FULL_PROGRAM_COMPLETED,
      isFetchingFullProgram: false,
      programFullInfo
    };
  }

  function requestFullProgramError(programFullError) {
    return {
      type: types.GET_FULL_PROGRAM_ERROR,
      isFetchingFullProgram: false,
      programFullError
    };
  }

function requestProgramHtmlDescr() {
  return {
    type: types.GET_PROGRAM_DESCRIPTION_REQUEST,
  };
}

function requestProgramHtmlDescrCompleted(programHtmlDescription) {
  return {
    type: types.GET_PROGRAM_DESCRIPTION_COMPLETED,
    programHtmlDescription
  };
}

function requestProgramHtmlDescrError(programHtmlDescrError) {
  return {
    type: types.GET_PROGRAM_DESCRIPTION_ERROR,
    programHtmlDescrError
  };
}

function requestProgramHtmlAnounce() {
  return {
    type: types.GET_PROGRAM_ANOUNCE_REQUEST,
  };
}

function requestProgramHtmlAnounceCompleted(programHtmlAnounce) {
  return {
    type: types.GET_PROGRAM_ANOUNCE_COMPLETED,
    programHtmlAnounce
  };
}

function requestProgramHtmlAnounceError(programHtmlAnounceError) {
  return {
    type: types.GET_PROGRAM_ANOUNCE_ERROR,
    programHtmlAnounceError
  };
}

  function requestModule() {
    return {
      type: types.GET_MODULE_REQUEST,
      isFetchingModule: true
    };
  }

  function requestModuleCompleted(moduleCard) {
    return {
      type: types.GET_MODULE_COMPLETED,
      isFetchingModule: false,
      moduleCard
    };
  }

  function requestModuleError(moduleCardError) {
    return {
      type: types.GET_MODULE_ERROR,
      isFetchingModule: false,
      moduleCardError
    };
  }

  function requestFullModule() {
    return {
      type: types.GET_FULL_MODULE_REQUEST,
      isFetchingFullModule: true
    };
  }

  function requestFullModuleCompleted(moduleFullInfo) {
    return {
      type: types.GET_FULL_MODULE_COMPLETED,
      isFetchingFullModule: false,
      moduleFullInfo
    };
  }

  function requestFullModuleError(moduleFullError) {
    return {
      type: types.GET_FULL_MODULE_ERROR,
      isFetchingFullModule: false,
      moduleFullError
    };
  }

  function requestPurpose() {
    return {
      type: types.GET_MODULE_PURPOSE_REQUEST,
      isFetchingPurpose: true
    };
  }

  function requestPurposeCompleted(purpose) {
    return {
      type: types.GET_MODULE_PURPOSE_COMPLETED,
      isFetchingPurpose: false,
      purpose
    };
  }

  function requestPurposeError(purposeError) {
    return {
      type: types.GET_MODULE_PURPOSE_ERROR,
      isFetchingPurpose: false,
      purposeError
    };
  }

  export function getPrograms() {
    return dispatch => {
      dispatch(requestPrograms());
      return api
        .getProgramsList()
        .then(response => {
          if (response.status === 200) {
            dispatch(requestProgramsCompleted(response.data));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({ message }) => message).join(", ");
            }
            logError(message);
            dispatch(requestProgramsError(err.response));
          } else {
            logError(err);
          }
        });
    };
  }

  export function getProgram(id) {
    return dispatch => {
      dispatch(requestProgram());
      return api
        .getProgramCard(id)
        .then(response => {
          if (response.status === 200) {
            let program = response.data;
            program = {
              ...program,
                targetName: program.targetGroup ? program.targetGroup.name : "",
                specName: program.speciality
                  ? (program.speciality.code ? program.speciality.code + " | " + program.speciality.name
                    :program.speciality.name) : "-",
                skillName: program.skill ? program.skill.name : "",
                skillType: program.skill ? program.skill.typeName : "",
                skillCis: program.skill ? program.skill.cis : "",
                trialFormName: program.trialForm ? program.trialForm.name : "",
                educationFormName: program.educationForm ? program.educationForm.name : "",
                organization : { ... program.organization },
                authors: program.authors
            };

            dispatch(requestProgramCompleted(program));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({ message }) => message).join(", ");
            }
            logError(message);
            dispatch(requestProgramError(err.response));
          } else {
            logError(err);
          }
        });
    };
  }

  export function getFullProgram(id) {
    return dispatch => {
      dispatch(requestFullProgram());
      return api
        .getProgramFullInfo(id)
        .then(response => {
          if (response.status === 200) {
            let resp = response.data;
            let program = {
              data: resp.data,
              info: resp.info,
              programFile: resp.info.program,
              certificateFile: resp.info.certificate,
              htmlAnnounce: resp.catalog ? resp.catalog.htmlAnnounce : "",
              htmlDescription: resp.catalog ? resp.catalog.htmlDescription : ""
            };
            //console.log(program);
            dispatch(requestFullProgramCompleted(program));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({ message }) => message).join(", ");
            }
            logError(message);
            dispatch(requestFullProgramError(err.response));
          } else {
            logError(err);
          }
        });
    };
  }

  export function getProgramHtmlDescription(id) {
    return dispatch => {
      dispatch(requestProgramHtmlDescr());
      return api.getProgramHtmlDescription(id)
        .then(response => {
          if (response.status === 200) {
            let respData = response.data;
            const descr = (respData && respData.data) ? respData.data.htmlDescription : '';
            dispatch(requestProgramHtmlDescrCompleted(descr));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({ message }) => message).join(", ");
            }
            logError(message);
            dispatch(requestProgramHtmlDescrError(err.response));
          } else {
            logError(err);
          }
        });
    }
  }

export function getProgramHtmlAnounce(id) {
  return dispatch => {
    dispatch(requestProgramHtmlAnounce());
    return api.getProgramHtmlAnounce(id)
      .then(response => {
        if (response.status === 200) {
          let respData = response.data;
          const anounce = (respData && respData.data) ? respData.data.htmlAnounce : '';
          //console.log(anounce);
          dispatch(requestProgramHtmlAnounceCompleted(anounce));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(requestProgramHtmlAnounceError(err.response));
        } else {
          logError(err);
        }
      });
  }
}

  export function getModule(id) {
    return dispatch => {
      dispatch(requestModule());
      return api
        .getModuleCard(id)
        .then(response => {
          if (response.status === 200) {
            let program = response.data;
            program = {
              ...program,
                specName: program.speciality ? program.speciality.name : "",
                specCode: program.speciality ? program.speciality.code : "",
                skillName: program.skill ? program.skill.name : "",
                skillType: program.skill ? program.skill.typeName : "",
                skillCis: program.skill ? program.skill.cis : "",
                trialFormName: program.trialForm ? program.trialForm.name : "",
                educationFormName: program.educationForm ? program.educationForm.name : "",
                organization : { ... program.organization },
                authors: program.authors
            };

            dispatch(requestModuleCompleted(program));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({ message }) => message).join(", ");
            }
            logError(message);
            dispatch(requestModuleError(err.response));
          } else {
            logError(err);
          }
        });
    };
  }

  export function getFullModule(id) {
    return dispatch => {
      dispatch(requestFullModule());
      return api
        .getModuleFullInfo(id)
        .then(response => {
          if (response.status === 200) {
            let program = response.data;
            program = {
              ...program,
              data: {
                ...program.data,
                metaTitle: "",
                metaDescr: ""
              },
              info : {
                ...program.info,
                expertise: program.info.expertise,
                action: program.info.action,
                specName: program.info.speciality ? program.info.speciality.name : "",
                specCode: program.info.speciality ? program.info.speciality.code : "",
                skillName: program.info.skill ? program.info.skill.name : "",
                skillType: program.info.skill ? program.info.skill.typeName : "",
                skillCis: program.info.skill ? program.info.skill.cis : "",
                skillId: program.info.skill ? program.info.skill.id : null,
                categoryId: program.info.skill ? program.info.skill.categoryId : null,
                categoryName: program.info.skill ? program.info.skill.categoryName : "",
                trialFormName: program.info.trialForm ? program.info.trialForm.name : "",
                educationFormName: program.info.educationForm ? program.info.educationForm.name : "",
                targetGroupName: program.info.targetGroup ? program.info.targetGroup.name : "",
              },
              programFile: program.info.program,
            };

            dispatch(requestFullModuleCompleted(program));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({ message }) => message).join(", ");
            }
            logError(message);
            dispatch(requestFullModuleError(err.response));
          } else {
            logError(err);
          }
        });
    };
  }

  export function getModulePurpose(id) {
    return dispatch => {
      dispatch(requestPurpose());
      return api
        .getModulePurpose(id)
        .then(response => {
          if (response.status === 200) {
            dispatch(requestPurposeCompleted(response.data));
          } else {
            return Promise.reject(response);
          }
          return Promise.resolve();
        })
        .catch(err => {
          if (err.response && err.response.status === 400) {
            let message = err.response;
            if (err.response.data && err.response.data.errors) {
              message = err.response.data.errors.map(({ message }) => message).join(", ");
            }
            logError(message);
            dispatch(requestPurposeError(err.response));
          } else {
            logError(err);
          }
        });
    };
  }

function requestOrgList() {
  return {
    type: types.GET_ORG_LIST_REQUEST,
    isFetchingOrganizations: true
  };
}

function requestOrgListCompleted(organizations) {
  return {
    type: types.GET_ORG_LIST_COMPLETED,
    isFetchingOrganizations: false,
    organizations
  };
}

function requestOrgListError(orgError) {
  return {
    type: types.GET_ORG_LIST_ERROR,
    isFetchingOrganizations: false,
    orgError
  };
}

//GET ORGANIZATION LIST
export function getOrganizations() {
  return dispatch => {
    dispatch(requestOrgList());
    return api.getEducationOrgList().then(response => {
      if (response.status === 200) {
        dispatch(requestOrgListCompleted(response.data));
      } else {
        return Promise.reject(response);
      }
      return Promise.resolve();
    })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestOrgListError(message));
        } else {
          logError(err);
          dispatch(requestOrgListError(createError("Не удалось загрузить список организаций")));
        }
      });
  };
}

function requestEduFormList() {
  return {
    type: types.GET_EDU_FORM_LIST_REQUEST,
    isFetchingEduForms: true
  };
}

function requestEduFormListCompleted(eduForms) {
  return {
    type: types.GET_EDU_FORM_LIST_COMPLETED,
    isFetchingEduForms: false,
    eduForms
  };
}

function requestEduFormListError(eduFormsError) {
  return {
    type: types.GET_EDU_FORM_LIST_ERROR,
    isFetchingEduForms: false,
    eduFormsError
  };
}

export function getEduForms() {
  return dispatch => {
    dispatch(requestEduFormList());
    return api.getEducationFormList().then(response => {
      if (response.status === 200) {
        dispatch(requestEduFormListCompleted(response.data));
      } else {
        return Promise.reject(response);
      }
      return Promise.resolve();
    })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestEduFormListError(message));
        } else {
          logError(err);
          dispatch(requestEduFormListError(createError("Не удалось загрузить список форм обучения")));
        }
      });
  };
}

function requestTargetGroupList() {
  return {
    type: types.GET_TARGET_GROUP_LIST_REQUEST,
    isFetchingTargetGroups: true
  };
}

function requestTargetGroupListCompleted(targetGroups) {
  return {
    type: types.GET_TARGET_GROUP_LIST_COMPLETED,
    isFetchingTargetGroups: false,
    targetGroups
  };
}

function requestTargetGroupListError(targetGroupsError) {
  return {
    type: types.GET_TARGET_GROUP_LIST_ERROR,
    isFetchingTargetGroups: false,
    targetGroupsError
  };
}

export function getTargetGroups() {
  return dispatch => {
    dispatch(requestTargetGroupList());
    return api.getTargetGroupList().then(response => {
      if (response.status === 200) {
        dispatch(requestTargetGroupListCompleted(response.data));
      } else {
        return Promise.reject(response);
      }
      return Promise.resolve();
    })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({message}) => message).join(", ");
          }
          logError(message);
          dispatch(requestTargetGroupListError(message));
        } else {
          logError(err);
          dispatch(requestTargetGroupListError(createError("Не удалось загрузить список категорий слушателей")));
        }
      });
  };
}

function requestActualPrograms() {
  return {
    type: types.GET_ACTUAL_PROGRAMS_REQUEST,
    isFetchingActualProgramsList: true
  };
}

function requestActualProgramsCompleted(actualPrograms) {
  return {
    type: types.GET_ACTUAL_PROGRAMS_COMPLETED,
    isFetchingActualProgramsList: false,
    actualPrograms
  };
}

function requestActualProgramsError(actualProgramsError) {
  return {
    type: types.GET_ACTUAL_PROGRAMS_ERROR,
    isFetchingActualProgramsList: false,
    actualProgramsError
  };
}

export function getActualPrograms() {
  return dispatch => {
    dispatch(requestActualPrograms());
    return api.getActualProgramsList()
      .then(response => {
        if (response.status === 200) {
          dispatch(requestActualProgramsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(requestActualProgramsError(err.response));
        } else {
          logError(err);
        }
      });
  };
}

export function getActualProgramsWithParams(targetGroup, municipal) {
  return dispatch => {
    dispatch(requestActualPrograms());
    return api.getActualProgramsListByTargetGroupAndMunicipal(targetGroup, municipal)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestActualProgramsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(requestActualProgramsError(err.response));
        } else {
          logError(err);
        }
      });
  };
}

function requestActualProgramGroups() {
  return {
    type: types.GET_ACTUAL_PROGRAM_GROUPS_REQUEST,
    isFetchingActualGroupList: true
  };
}

function requestActualProgramGroupsCompleted(actualGroups) {
  return {
    type: types.GET_ACTUAL_PROGRAM_GROUPS_COMPLETED,
    isFetchingActualGroupList: false,
    actualGroups
  };
}

function requestActualProgramGroupsError(actualGroupsError) {
  return {
    type: types.GET_ACTUAL_PROGRAM_GROUPS_ERROR,
    isFetchingActualGroupList: false,
    actualGroupsError
  };
}

export function getActualProgramGroups(programId) {
  return dispatch => {
    dispatch(requestActualProgramGroups());
    return api.getActualProgramGroups(programId)
      .then(response => {
        if (response.status === 200) {
          dispatch(requestActualProgramGroupsCompleted(response.data));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(requestActualProgramGroupsError(err.response));
        } else {
          logError(err);
        }
      });
  };
}

  export default {
    getPrograms,
    getActualPrograms,
    getActualProgramsWithParams,
    getActualProgramGroups,
    getProgram,
    getFullProgram,
    getProgramHtmlDescription,
    getProgramHtmlAnounce,
    getModule,
    getFullModule,
    getModulePurpose,
    getOrganizations,
    getEduForms,
    getTargetGroups
  };
